import {RouteConfig} from 'vue-router';
import {Routes} from '@/router/Routes';

const BranchesPanel = () => import(/* webpackChunkName: "Branches" */ '@/modules/branches/views/BranchesPanel.vue');
const BranchDetails = () => import(/* webpackChunkName: "Branches" */ '@/modules/branches/views/BranchDetails.vue');

const BranchesRoutes: Array<RouteConfig> = [
  {
    path: '',
    name: Routes.BRANCHES.BRANCHES_LIST,
    component: BranchesPanel,
  },
  {
    path: ':id',
    name: Routes.BRANCHES.BRANCH_DETAILS,
    component: BranchDetails,
  },
];

export default BranchesRoutes;
